import React from 'react';
import PropTypes from 'prop-types';
import {useIntl} from 'react-intl';
import {REASSIGN_SCHEME_TYPES} from '@constants';
import AuthTypeSelector from '../components/AuthTypeSelector';
import QuestionAnswerFields from '../components/QuestionAnswerFields';
import SMSField from '../components/SMSField';
import './reassignAuth.less';

const ReassignAuth = ({auth, setAuth, enforcedAuth}) => {
    const intl = useIntl();

    const handleAuthTypeChange = (newAuthType) => {
        let updatedAuth;

        switch (newAuthType) {
            case REASSIGN_SCHEME_TYPES.QNA:
                updatedAuth = {
                    scheme: newAuthType,
                    challenges: [
                        {question: '', answer: '', maskInput: false}
                    ]
                };
                break;
            case REASSIGN_SCHEME_TYPES.SMS:
                updatedAuth = {
                    scheme: newAuthType,
                    challenges: [{question: ''}]
                };
                break;
            case REASSIGN_SCHEME_TYPES.EMAIL:
            default:
                updatedAuth = {
                    scheme: newAuthType
                };
                break;
        }

        setAuth(updatedAuth);
    };

    const handleQAChallengesChange = (updatedChallenges) => {
        setAuth({
            ...auth,
            challenges: updatedChallenges
        });
    };

    const handleSMSPhoneNumberChange = (phoneNumber) => {
        setAuth({
            ...auth,
            challenges: [{question: phoneNumber}]
        });
    };

    const getShowQAFields = () => auth?.scheme === REASSIGN_SCHEME_TYPES.QNA;
    const getShowSMSField = () => auth?.scheme === REASSIGN_SCHEME_TYPES.SMS;
    const getSMSPhoneNumber = () => auth?.challenges?.[0]?.question || '';

    return (
        <div className="reassign-auth" data-wdio="test-reassign-auth">
            <div className="reassign-auth__description">
                {intl.formatMessage({
                    id: 'oss.components.ReassignAuth.description',
                    defaultMessage: 'Select additional authentication method for the new recipient. This will be required before they can access the document.'
                })}
            </div>

            <AuthTypeSelector
                selectedAuthType={auth?.scheme || REASSIGN_SCHEME_TYPES.EMAIL}
                onAuthTypeChange={handleAuthTypeChange}
                isEnforcedAuth={enforcedAuth}
            />

            {getShowQAFields() && (
                <QuestionAnswerFields
                    challenges={auth.challenges || []}
                    onChallengesChange={handleQAChallengesChange}
                />
            )}

            {getShowSMSField() && (
                <SMSField
                    phoneNumber={getSMSPhoneNumber()}
                    onPhoneNumberChange={handleSMSPhoneNumberChange}
                />
            )}
        </div>
    );
};

ReassignAuth.propTypes = {
    auth: PropTypes.shape({
        scheme: PropTypes.oneOf([
            REASSIGN_SCHEME_TYPES.EMAIL,
            REASSIGN_SCHEME_TYPES.QNA,
            REASSIGN_SCHEME_TYPES.SMS
        ]).isRequired,
        challenges: PropTypes.array
    }).isRequired,
    setAuth: PropTypes.func.isRequired,
    enforcedAuth: PropTypes.shape({
        scheme: PropTypes.oneOf([
            REASSIGN_SCHEME_TYPES.EMAIL,
            REASSIGN_SCHEME_TYPES.QNA,
            REASSIGN_SCHEME_TYPES.SMS
        ])
    })
};

ReassignAuth.defaultProps = {
    enforcedAuth: null
};

export default ReassignAuth;
